import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var CloseCircleIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsxs(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ _jsxs("g", {
                fill: "currentColor",
                fillRule: "evenodd",
                clipPath: "url(#a)",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.47 4.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.47 11.53a.75.75 0 0 1 0-1.06l6-6a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ _jsx("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    }));
};
